
  export default {
    middleware: ['blog/articles', 'breadcrumbs', 'jumbotron', 'meta-tags'],
    meta: {
      jumbotronScope: 'blog',
      paginated: true,
      perPage: 12,
      showNewsletterSignup: true
    },
    data () {
      return {
        address: null,
        searchLink: `${this.$railsHost()}/compare-tv-broadband-phone/search/`
      };
    },
    computed: {
      author () {
        return this.$store.getters['blog/getAuthor'];
      },
      category () {
        const categoryTitle = this.$route.params.category;
        return categoryTitle ? this.$store.getters['blog/getCategories'].find(c => c.title === categoryTitle) : null;
      },
      categoryDescription () {
        return this.category ? this.category.description : null;
      },
      menu () {
        if (this.category.title === 'gas-electricity') {
          return { key: 'energy', items: ['dualfuel', 'electricity', 'gas'] };
        } else if (this.category.title === 'insurance') {
          return { key: 'insurance', items: ['life-insurance', 'mortgage-protection', 'serious-illness', 'income-protection'] };
        }
        return { key: 'banking', items: ['mortgages', 'savings', 'currents', 'cards', 'prepay-cards', 'loans'] };
      },
      query () {
        return this.$store.getters['blog/getMeta'].query;
      },
      tag () {
        return this.$route.params.tag;
      },
      articles () {
        return this.$store.getters['blog/getList'];
      }
    },
    beforeDestroy () {
      this.$store.dispatch('blog/clearAuthors');
    },
    methods: {
      path (product) {
        return {
          cards: '/compare-credit-cards/',
          currents: '/compare-current-accounts/',
          'mortgage-protection': '/compare-mortgage-protection-insurance/',
          'prepay-cards': '/compare-prepaid-credit-cards/',
          savings: '/compare-savings-accounts/',
          'serious-illness': '/compare-serious-illness-cover/'
        }[product] || `/compare-${product}/`;
      },
      addressSelect (address) {
        this.address = address;
        this.$nextTick(() => this.$el.querySelector('form').submit());
      }
    }
  };
